export type Country = {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
};

// Subset of countries with calling codes. Extend as needed.
export const countries: Country[] = [
  // Keep United States at the top
  { code: "US", label: "United States", phone: "1", suggested: true },
  { code: "TJ", label: "Tajikistan", phone: "992" },

  // Alphabetical order by label for the rest
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AU", label: "Australia", phone: "61" },
  { code: "AT", label: "Austria", phone: "43" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "CA", label: "Canada", phone: "1" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CZ", label: "Czechia", phone: "420" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "FR", label: "France", phone: "33" },
  { code: "DE", label: "Germany", phone: "49" },
  { code: "GR", label: "Greece", phone: "30" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "IN", label: "India", phone: "91" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "JP", label: "Japan", phone: "81" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PL", label: "Poland", phone: "48" },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RU", label: "Russia", phone: "7" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "KR", label: "South Korea", phone: "82" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TR", label: "Türkiye", phone: "90" },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "AE", label: "United Arab Emirates", phone: "971" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
];
